import { UntypedFormBuilder, UntypedFormGroup, FormControl } from '@angular/forms';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-checkqueuezone',
  templateUrl: './checkqueuezone.component.html',
  styleUrls: ['./checkqueuezone.component.css']
})
export class CheckqueuezoneComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  SetectZone: UntypedFormGroup;
  constructor(
    private spinner: NgxSpinnerService,
    private fb: UntypedFormBuilder
  ) {
    this.SetectZone = this.fb.group({
      zone: '',
      round: '',
      txtfind: ''
    });
  }
  ngOnInit(): void {
    this.LoadZone();
    this.LoadRound();
  }

  ExportExcel() {

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'ตรวจสอบการใช้คิวโซน[' + this.zshow + '] รอบที่' + this.rshow + '.xlsx');
  }

  usedlist = [];
  zshow = '';
  rshow = '';
  qtype = 0;
  alllist = [];

  LoadCheckusedbyzone(qtype: number) {
    this.spinner.show();
    //this.qtype = qtype;
    let data = this.SetectZone.value;
    //supzoneQ='${data.zone}'
    let zone = '';
    let type = '';
    if (data.zone == 'all') zone = ``
    else zone = `[supzoneQ]='${data.zone}'and `
    if (qtype == 0) type = `[qtypeQ] in(1,3)and `
    else type = `[qtypeQ]='${qtype}'and `
    this.usedlist = [];

    //let zonet = data.zone[0];
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_barcodeloopQ_use]&w=${zone}${type}[loop_id]='${data.round}'order by[q_idQ]`;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=qid.q_id%20q_id0,qid.[groupcode]groupcode0,qid.[supzone]supzone0,left(qid.groupcode,3)supzoneQ,qc.*&f=[dbQBRD].[dbo].[" + tq + "] qid left outer join dbQBRD.[dbo].[v_qcard_use]qc on qid.q_id=qc.q_id and qc.Qtype=" + qtype + " and qc.ref_doc1='" + data.round + "'&w=(qid.supzone='" + data.zone[0] + "' or left(qid.groupcode,3)='" + data.zone[1] + "') and qid.ckdata=1 order by qid.q_id";
    this.zshow = data.zone[0];
    this.rshow = data.round;
    axios.get(url).then(res => {
      console.log('res:' ,res);
      if(!res.data.length) {
        alert('!!เกิดปัญหาในการโหลดข้อมูลจากเซริ์ฟเวอร์ กรุณาลองใหม่อีกครั้ง');
        this.usedlist = [];
      } else {
        let data = res.data;
        this.usedlist = data;
      }

      this.spinner.hide();
    })
      .catch(err => { throw err })
  }
  /* Data_a=[]
   setDataTeble(id=0){
     if(id==0)this.usedlist = this.Data_a;
     else this.usedlist = this.Data_a.filter((el:any)=> el.Qtype == id);
   }*/

  zonelist = [];
  LoadZone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url).then(res => {
      this.zonelist = res.data.recordset;
    })
      .catch(err => { throw err })
  }

  roundlist = [];
  loopType = [];
  LoadRound() {
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/select_loop_id_by_qtype?qtype=1";
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=[ref_doc1][loop_id],count(*)cnt&f=[dbQBRD].[dbo].[qcard_6768]&w=[print_q]<>0 and cast(len([ref_doc1])as int)>0 group by[ref_doc1]order by[ref_doc1]";
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_loop_q]&w=qtype=1`;
    axios.get(url).then(res => {
      let data = res.data;
      data.sort((a, b) => a.loop_id.localeCompare(b.loop_id));
      this.roundlist = data;
    }).catch(err => { throw err })
  }
  getBGColor(reba: string, print_q: string): string {
    const intensity = 20 + (parseInt(print_q)) * 15; // ความเข้ม 10%-50%
    return `rgba(	${reba}, ${intensity / 100})`; // สีฟ้าพร้อมความโปร่งใส
  }

  THtoLocalstring2(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      // weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

}
